export const FREE_EXECUTIVE_MAX_COMPANIES = 5;
